// components/ProductCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../utils/constants'; // Import getImageUrl

const ProductCard = ({ product }) => {
  const discountedPrice = product.price * (1 - product.discount_percent / 100);
  
  // Use getImageUrl helper
  const imageUrl = product.images?.[0] 
    ? getImageUrl(product.images[0].filepath, 'products')
    : 'https://via.placeholder.com/300x300/F3F4F6/9CA3AF?text=NAa+Collection';

  return (
    <Link 
      to={`/products/${product.id}`} 
      className="block bg-white border border-gray-100 overflow-hidden transition-all duration-300 hover:border-black hover:shadow-lg hover:shadow-gray-200 hover:-translate-y-1"
    >
      {/* Image Container with Discount */}
      <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 border-b border-gray-100 aspect-square overflow-hidden">
        <img
          src={imageUrl}
          alt={product.title}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
          loading="lazy"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://via.placeholder.com/300x300/F3F4F6/9CA3AF?text=NAa+Collection";
          }}
        />
        
        {/* Discount Badge - Changed to Black */}
        {product.discount_percent > 0 && (
          <div className="absolute top-3 left-3 bg-gradient-to-r from-black to-gray-800 text-white text-xs font-bold px-3 py-1.5 shadow-lg z-10">
            -{product.discount_percent}%
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="p-4">
        <h3 className="text-sm font-medium text-gray-800 line-clamp-2 ">
          {product.title}
        </h3>

        <div className="flex items-baseline gap-2 flex-wrap mb-4 mt-2">
          <span className="text-xl font-bold text-red-500">
            ${(discountedPrice || product.price).toFixed(2)}
          </span>
          
          {product.discount_percent > 0 && (
            <span className="text-xs text-red-500 line-through">
              ${product.price.toFixed(2)}
            </span>
          )}
        </div>

        <button className="w-full bg-black hover:bg-gray-800 text-white py-2.5 text-sm font-medium transition-all shadow-md hover:shadow-lg">
          មើលលំអិត
        </button>
      </div>
    </Link>
  );
};

export default ProductCard;